import {magicModdleDescriptor as customDescriptor} from './BPMNModeler';
import BpmnModdle from 'bpmn-moddle';
import {databaseViewApi} from './redux/databaseView';


export function createProcessModel(moddle)
	{
	var ownerTable=loadOwnerTable(moddle);

	function findByID(stateID)
		{
		for (const process of moddle.rootElements.filter((x)=>x.$type==="bpmn:Process"))
			{
			var found=findElement(process,stateID);

			if (found)
				return found;
			}

		return null;
		}

	function findStarting(stateID)
		{
		var processes=moddle.rootElements.filter((e)=>e.$type==="bpmn:Process");

		if (!stateID)
			return processes.flatMap((process)=>process.flowElements?.filter((e)=>e.$type==="bpmn:StartEvent")||[]);

		var state=findByID(stateID);

		return state?[state]:[];
		}

	function getStateOwner(stateID)
		{
		var state=findByID(stateID);

		if (!state)
			return null;

		return findStateOwner(state,ownerTable);
		}

	function getVariables()
		{
		var variables={};

		for (const collaboration of moddle.rootElements.filter((x)=>x.$type==="bpmn:Collaboration"))
			{
			if (!collaboration.processVariables)
				continue;

			collaboration.processVariables.values.forEach((variable)=>
				{
				variables[variable.get("name")]=variable.get("value");
				});
			}

		return variables;
		}

	return {
		findElement:findByID,
		findStartingElements:findStarting,
		getStateOwner,
		getVariables
		};
	}


export async function loadProcessModdle(dispatch,processID)
	{
	try
		{
		const moddle=new BpmnModdle({custom:customDescriptor});
		var process=await dispatch(databaseViewApi.endpoints.loadProcess.initiate(processID));

		if (!process.data||process.data.failure||!process.data.data?.[0]?.components)
			{
			console.error("Unable to load process",processID,process);
			return null;
			}

		process=JSON.parse(process.data.data[0].components);

		if (!process.components)
			{
			console.error("Process has no BPMN components",processID);
			return null;
			}

		var {rootElement:moddleInstance}=await moddle.fromXML(process.components);

		return moddleInstance;
		}
	catch (e)
		{
		console.error("Unable to load BPMN process",processID,e);
		return null;
		}
	}


function findElement(root,id)
	{
	if (!root.flowElements)
		return null;

	var found=null;

	root.flowElements.some((e)=>
		{
		if (e.id==id)
			{
			found=e;
			return true;
			}

		if (e.$type==="bpmn:SubProcess")
			{
			var s=findElement(e,id);

			if (s)
				{
				found=s;
				return true;
				}
			}

		return false;
		});

	return found;
	}


function loadOwnerTable(moddle)
	{
	var processes=moddle.rootElements.filter((e)=>e.$type==="bpmn:Process");
	var ownerTable={};

	processes.forEach((process)=>
		{
		process.laneSets?.forEach((laneSet)=>
			{
			laneSet.lanes?.forEach((lane)=>
				{
				lane.flowNodeRef?.forEach((node)=>
					{
					ownerTable[node.id]=lane.name;
					});
				});
			});
		});

	return ownerTable;
	}


function findStateOwner(state,stateOwnerTable)
	{
	if (stateOwnerTable[state.id])
		return stateOwnerTable[state.id];

	if (state.$parent)
		return findStateOwner(state.$parent,stateOwnerTable);

	return "_initiator";
	}